import { onUnmounted } from 'vue';
import store from '@/store';

export const useLoader = () => {
    const display = (active: boolean, text = 'Loading...') => {
        store.commit('loader', { active, text });
    };

    const updateText = (text: string) => {
        store.commit('loader', { ...store.state.loader, text });
    };

    const execLoadedFn = async (callback: () => Promise<unknown>, text?: string) => {
        display(true, text);
        await callback();
        display(false);
    };

    onUnmounted(() => {
        display(false);
    });

    return { display, execLoadedFn, updateText, isLoading: store.state.loader.active as Readonly<boolean> };
};
